import { render, staticRenderFns } from "./Clyy.vue?vue&type=template&id=864244e2&scoped=true"
import script from "./Clyy.vue?vue&type=script&lang=js"
export * from "./Clyy.vue?vue&type=script&lang=js"
import style0 from "./Clyy.vue?vue&type=style&index=0&id=864244e2&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864244e2",
  null
  
)

export default component.exports